import { WorkspacePowerLevels } from 'modules/CreateWorkspaceModal/types';
import { PermissionId, workspacesConfig } from 'utils/powerLevelsConfig';

const useScopedPowerLevels = (permissions: Record<PermissionId, boolean>): WorkspacePowerLevels => {
  const result: WorkspacePowerLevels = { workspace: 0, chat: 0, meeting: 0 };

  for (const [id, enabled] of Object.entries(permissions) as Array<[PermissionId, boolean]>) {
    if (!enabled) continue;
    const entry = workspacesConfig[id];
    if (!entry) continue;
    if (entry.powerLevel > result[entry.scope]) result[entry.scope] = entry.powerLevel;
  }

  return result;
};

export default useScopedPowerLevels;
